import { getDateTimeString } from '@advanza/func'
import { InputField } from '@advanza/input'
import { Icon } from '@advanza/ui'
import NiceModal from '@ebay/nice-modal-react'
import DateInputModal from 'components/pauses/DateInputModal'

interface Props {
    className?: string
    icon?: string
    placeholder?: string | null
    modalTitle?: string
    date?: Date
    setDate: (date: Date) => void
    defaultMonth?: Date
    error?: string | boolean | null
    onDeselect?: () => void
}

const DateInput = ({
    className,
    icon = 'date_range',
    placeholder,
    modalTitle,
    date,
    setDate,
    defaultMonth,
    error,
    onDeselect,
}: Props) => {
    const openPicker = async () => {
        const picked: Date | null | undefined = await NiceModal.show(DateInputModal, {
            modalTitle,
            date,
            defaultMonth,
            deselectable: !!onDeselect,
        })

        if (picked) {
            setDate(picked)
        } else if (picked === null) {
            onDeselect?.()
        }
    }

    return (
        <InputField
            after={<Icon name={icon} primColor />}
            hideAfterIconStyle
            classNames={className}
            inputPlaceholder={placeholder}
            value={date ? getDateTimeString(date, 'dd-MM-yyyy') : ''}
            onFocus={(event) => {
                // Prevent dialog focus restoration from retriggering onFocus and reopening the picker.
                event.currentTarget.blur()
                openPicker()
            }}
            readOnly
            error={error}
        />
    )
}

export default DateInput
